import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { PageStub } from '#shared/components/PageStub';

const ConstructorAsyncLazy = loadable(
    () => import(/* webpackChunkName: "Constructor" */ './components/Constructor/ConstructorSuspense')
);

export const ConstructorAsync = () => (
    <Suspense fallback={<PageStub />}>
        <ConstructorAsyncLazy />
    </Suspense>
);
